import API_URLS from '@/api/API_URLS.js';
import { httpGet, httpPost } from '@/api/request';
export const getNewsList = params => httpPost(API_URLS.NEWS_LIST, params);
export const getNewsList1 = params => httpGet(API_URLS.NEWS_LIST, params);
export const getNewsTypeList = () => httpGet(API_URLS.NEWS_TYPE_LIST);